import * as Schema from "effect-app/Schema"
import type { Top } from "effect/Schema"

export * from "effect-app/Schema"

/** Exact-optional fields with constructor defaults stripped — a partial-update payload that stays partial. */
export const makePatch = <F extends Schema.Struct.Fields>(fields: F) => Schema.makeExactOptional(fields)

/**
 * Since effect beta.107 `Schema.Redacted` is JSON-encodable by default
 * (`disallowJsonEncode` is opt-in), so these are thin aliases kept for
 * existing call sites.
 */
export function JsonEncodableRedacted<S extends Top>(value: S, options?: {
  readonly label?: string | undefined
}): Schema.Redacted<S> {
  return Schema.Redacted(value, options)
}

export function JsonEncodableRedactedFromValue<S extends Top>(value: S, options?: {
  readonly label?: string | undefined
}): Schema.RedactedFromValue<S> {
  return Schema.RedactedFromValue(value, options)
}
